import React from 'react';
function TeamCard(props) {
    return (
        <div className='team__card__wrapper col-md-4'>
            <div className='team__card__container'>
                <div>
                    <img className='team__card__image' src={props.img} alt="" />
                </div>
                <div>
                    <div className='name'><b>{props.name}</b></div>
                    <div className='position'>{props.position}</div>
                    <div className='clgname'>VIT-AP</div>
                    <div className="social">
                        <a href={props.linkedin}>
                        <i className="fab fa-linkedin-in"></i>
                        </a>
                        <a href={props.email}>
                            <i className="fas fa-envelope"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default TeamCard;